import _classCallCheck from "/supplier360/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/supplier360/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/supplier360/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/supplier360/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/supplier360/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

import PropTypes from 'prop-types';
import React, { Component, Fragment } from 'react';

var adaptFileEventToValue = function adaptFileEventToValue(delegate) {
  return function (e) {
    return delegate(e.target.files[0]);
  };
};

var emptyFunction = function emptyFunction() {};

var FileInput = /*#__PURE__*/function (_Component) {
  _inherits(FileInput, _Component);

  function FileInput() {
    _classCallCheck(this, FileInput);

    return _possibleConstructorReturn(this, _getPrototypeOf(FileInput).apply(this, arguments));
  }

  _createClass(FileInput, [{
    key: "openFileDialog",
    value: function openFileDialog() {
      this.inputElement && this.inputElement.click();
    }
  }, {
    key: "render",
    value: function render() {
      var _this = this;

      var _props = this.props,
          _props$onChange = _props.onChange,
          onChange = _props$onChange === void 0 ? emptyFunction : _props$onChange,
          _props$onBlur = _props.onBlur,
          onBlur = _props$onBlur === void 0 ? emptyFunction : _props$onBlur,
          _props$input = _props.input;
      _props$input = _props$input === void 0 ? {} : _props$input;

      var inputOnChange = _props$input.onChange,
          inputOnBlur = _props$input.onBlur,
          meta = _props.meta,
          name = _props.name,
          buttonText = _props.buttonText,
          buttonClassName = _props.buttonClassName,
          disabled = _props.disabled,
          restOfProps = _objectWithoutProperties(_props, ['onChange', 'onBlur', 'input', 'meta', 'name', 'buttonText', 'buttonClassName', 'disabled']);

      return React.createElement(Fragment, null, React.createElement('button', {
        disabled: disabled,
        type: 'button',
        className: buttonClassName,
        onClick: function onClick() {
          return _this.openFileDialog();
        }
      }, buttonText), React.createElement('input', _extends({
        onChange: adaptFileEventToValue(inputOnChange || onChange),
        onBlur: adaptFileEventToValue(inputOnBlur || onBlur),
        disabled: disabled,
        type: 'file',
        name: name,
        style: {
          display: 'none'
        },
        ref: function ref(el) {
          return _this.inputElement = el;
        }
      }, restOfProps)));
    }
  }]);

  return FileInput;
}(Component);

FileInput.propTypes = {
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  input: PropTypes.shape({
    onChange: PropTypes.func,
    onBlur: PropTypes.func
  }),
  meta: PropTypes.any,
  buttonText: PropTypes.node,
  buttonClassName: PropTypes.string
};
FileInput.defaultProps = {
  buttonText: 'Choose file',
  buttonClassName: 'Btn-default Btn-default-primary'
};
export default FileInput;